module.exports = __webpack_public_path__ + "img/forum_active.png";